import { render } from "./index.vue?vue&type=template&id=59ada758&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/data/jenkins/workspace/auto-build-release-node-server-new-2024/TMP/PROD/ashe/ashe-activity/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__